// Utility functions for local storage management

import { User } from 'store/slices/users';

export function setUserInLocalStorage(user: User) {
  localStorage.setItem('user', JSON.stringify(user));
}

export function setCampaignIdInLocalStorage(campaign_id: number | null) {
  if (campaign_id !== null) {
    localStorage.setItem('campaignID', campaign_id.toString());
  } else {
    localStorage.removeItem('campaignID');
  }
}

export function getUserFromLocalStorage(): User | null {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
}

export function getCampaignIdFromLocalStorage(): number | null {
  const campaignID = localStorage.getItem('campaignID');
  return campaignID ? parseInt(campaignID, 10) : null;
}

export function setTokenInLocalStorage(token: string) {
  localStorage.setItem('token', token);
}

export function getTokenFromLocalStorage(): string | null {
  return localStorage.getItem('token');
}

export function clearLocalStorage() {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('campaignID'); // Clear campaignID as well
}

export function isUserExist(): boolean {
  const user = localStorage.getItem('user');
  return user !== null;
}

export function isTokenExist(): boolean {
  const token = localStorage.getItem('token');
  return token !== null;
}

export function isAuthenticated(): boolean {
  return isUserExist() && isTokenExist();
}
